// relationshipsService.js
/**
 * Service for managing relationships between assets and files - Direct APS API calls
 */

/**
 * Remove 'b.' prefix from a project ID
 * @param {string} str
 * @returns {string}
 */
function removeBPrefix(str) {
    return str.replace(/^b\./, '');
}

/**
 * Create a relationship between an asset and a file
 * @param {string} accessToken - The access token for authentication
 * @param {string} projectIdRaw - The raw project ID (may include 'b.' prefix)
 * @param {Object} relationshipData - The relationship data
 * @param {string} relationshipData.assetId - The asset ID
 * @param {string} relationshipData.fileId - The file ID (URN)
 * @returns {Promise<Object>} The API response
 */
export const createRelationship = async (
    accessToken,
    projectIdRaw,
    relationshipData
) => {
    if (!accessToken || !projectIdRaw || !relationshipData) {
        throw new Error('Missing required parameters for creating relationship');
    }

    const projectIdParamNoB = removeBPrefix(projectIdRaw); // Container ID is project ID without 'b.'
    const { assetId, fileId } = relationshipData;

    const newRelationShip = [
        {
            entities: [
                {
                    domain: 'autodesk-bim360-asset',
                    type: 'asset',
                    id: assetId,
                },
                {
                    domain: 'autodesk-bim360-documentmanagement',
                    type: 'documentlineage',
                    id: fileId,
                },
            ]
        }
    ];

    // console.log('[Relationship Service] === DETAILED REQUEST DEBUG ===');
    // console.log('[Relationship Service] Container ID (Project ID without b.):', projectIdParamNoB);
    // console.log('[Relationship Service] Access Token (first 20 chars):', accessToken?.substring(0, 20) + '...');
    // console.log('[Relationship Service] Relationship payload:', JSON.stringify(newRelationShip, null, 2));
    // console.log('[Relationship Service] Asset ID:', assetId);
    // console.log('[Relationship Service] File ID:', fileId);

    // Prepare the request headers
    const requestHeaders = new Headers({
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${accessToken}`
    });

    const requestUrl = `https://developer.api.autodesk.com/bim360/relationship/v2/containers/${projectIdParamNoB}/relationships`;
    // console.log('[Relationship Service] Request URL:', requestUrl);
    // console.log('[Relationship Service] Request Method: PUT');
    // console.log('[Relationship Service] Request Headers:', {
    //     'Content-Type': 'application/json',
    //     'Authorization': `Bearer ${accessToken?.substring(0, 20)}...`
    // });
    // console.log('[Relationship Service] Request Body:', JSON.stringify(newRelationShip, null, 2));

    // Prepare the request object
    const request = new Request(requestUrl, {
        method: 'PUT',
        headers: requestHeaders,
        body: JSON.stringify(newRelationShip)
    });

    // console.log('[Relationship Service] === SENDING REQUEST ===');
    const response = await fetch(request);
    // console.log('[Relationship Service] Response Status:', response.status);
    // console.log('[Relationship Service] Response Status Text:', response.statusText);

    try {
        // Check if the response is okay
        if (!response.ok) {
            const errorText = await response.text();
            // console.log('[Relationship Service] Error Response Body:', errorText);
            throw new Error(`HTTP error creating relationship: ${response.status} ${response.statusText} - ${errorText}`);
        }
        const result = await response.json();
        // console.log('[Relationship Service] Success! Relationship created:', result);
        return result;

    } catch (error) {
        // Log and rethrow any errors encountered
        // console.error('[Relationship Service] Error creating Relationship:', error);
        throw error;
    }
};

